import { useState, useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PaywallScreen({ user, onSubscribed }) {
  const [loading, setLoading] = useState(false);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("payment") === "success") {
      window.history.replaceState({}, "", window.location.pathname);
      checkSubscription();
    }
    if (user?.subscription) {
      setSubscription(user.subscription);
    }
  }, [user]);

  const checkSubscription = async () => {
    try {
      const token = localStorage.getItem("session_token");
      const res = await fetch(`${BACKEND_URL}/api/auth/me`, {
        credentials: "include",
        headers: token ? { "Authorization": `Bearer ${token}` } : {},
      });
      if (res.ok) {
        const data = await res.json();
        if (data.subscription?.active) onSubscribed && onSubscribed(data);
      }
    } catch (e) { console.error(e); }
  };

  const handleSubscribe = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("session_token");
      const res = await fetch(`${BACKEND_URL}/api/stripe/create-checkout`, {
        method: "POST",
        credentials: "include",
        headers: token ? { "Authorization": `Bearer ${token}` } : {},
      });
      const data = await res.json();
      if (data.checkout_url) window.location.href = data.checkout_url;
    } catch (e) {
      alert("Errore durante il pagamento. Riprova.");
    } finally { setLoading(false); }
  };

  const isTrialExpired = !subscription?.active;
  const daysLeft = subscription?.days_left;

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1a3a0a 0%, #2d5a1b 50%, #1a3a0a 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem", fontFamily: "'IBM Plex Sans', sans-serif" }}>
      <div style={{ maxWidth: 420, width: "100%", background: "white", borderRadius: 20, overflow: "hidden", boxShadow: "0 25px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ background: "linear-gradient(135deg, #2d5a1b, #4a8a2a)", padding: "2rem 1.5rem", textAlign: "center", color: "white" }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>🍇</div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>Il Mio Vigneto</h1>
          <p style={{ margin: "8px 0 0", opacity: 0.85, fontSize: 14 }}>
            {isTrialExpired ? "Il tuo periodo di prova è scaduto" : `Periodo di prova: ${daysLeft} giorni rimanenti`}
          </p>
        </div>
        <div style={{ padding: "1.5rem" }}>
          {isTrialExpired && (
            <div style={{ background: "#fff3cd", border: "1px solid #ffc107", borderRadius: 10, padding: "12px 16px", marginBottom: "1.25rem", fontSize: 14, color: "#856404", textAlign: "center" }}>
              ⚠️ Per continuare ad usare l'app, attiva il piano Premium
            </div>
          )}
          <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
            <div style={{ fontSize: 13, color: "#666", marginBottom: 4 }}>Piano Premium annuale</div>
            <div style={{ display: "flex", alignItems: "baseline", justifyContent: "center", gap: 4 }}>
              <span style={{ fontSize: 42, fontWeight: 700, color: "#2d5a1b" }}>€49</span>
              <span style={{ fontSize: 16, color: "#666" }}>/anno</span>
            </div>
            <div style={{ display: "inline-block", background: "#fff3e0", color: "#e65100", borderRadius: 20, padding: "3px 12px", fontSize: 13, fontWeight: 500, marginTop: 4 }}>
              La conformità che ti protegge dalle sanzioni
            </div>
          </div>
          <div style={{ marginBottom: "1.5rem" }}>
            {["🌿 Vigneti illimitati", "🤖 Diagnosi AI illimitate", "📓 Quaderno di campagna completo", "📄 Stampa registro PAN A4", "🔔 Promemoria tesserino fitosanitario", "✍️ Compilazione AI da testo libero", "💬 Forum riservato + supporto email"].map((f, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: i < 6 ? "1px solid #f0f0f0" : "none", fontSize: 14, color: "#333" }}>
                <span style={{ color: "#2d5a1b", fontWeight: 700 }}>✓</span>{f}
              </div>
            ))}
          </div>
          <button onClick={handleSubscribe} disabled={loading} style={{ width: "100%", padding: "14px", background: loading ? "#ccc" : "linear-gradient(135deg, #2d5a1b, #4a8a2a)", color: "white", border: "none", borderRadius: 12, fontSize: 16, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer" }}>
            {loading ? "Caricamento..." : "Abbonati ora — €49/anno →"}
          </button>
          <p style={{ textAlign: "center", fontSize: 12, color: "#999", marginTop: 12, marginBottom: 0 }}>
            Pagamento sicuro con Stripe · Annulla in qualsiasi momento
          </p>
        </div>
      </div>
    </div>
  );
}
